export default "__VITE_ASSET__6b608e26__"